export default __webpack_public_path__ + "static/Logo-Litcoin-f2d5ce50b66f3b230e46d65d3ab83b43.png";